@if (!isLoading) {
  <div class="main-container" data-cy="forms-builder-polished-container">
    <div style="flex-basis: 220px; display: flex;" data-cy="forms-builder-polished-sidebar">
      <div class="form-detail-container" data-cy="forms-builder-polished-form-details">
        <div data-cy="forms-builder-polished-header">
          <h5 class="form-detail-title" data-cy="forms-builder-polished-title">
            Form Builder.
            <button mat-icon-button
              class="keyboard-shortcuts-help"
              [matTooltip]="getKeyboardShortcutsTooltip()"
              matTooltipClass="keyboard-shortcuts-tooltip">
              <lucide-icon name="keyboard" [size]="20"></lucide-icon>
            </button>
          </h5>
          @if (cfgFormIsLoading) {
            <mat-spinner class="form-detail-spinner" [diameter]="20" data-cy="forms-builder-polished-spinner"></mat-spinner>
          }
          <div style="display: flex;" class="form-action-button-container" data-cy="forms-builder-polished-actions">
            <button mat-icon-button [disabled]="!formIsEditable || !selectedCfgForm" (click)="deleteForm()"
              matTooltip="Delete selected form"
              data-cy="forms-builder-polished-delete-icon">
              <i class="material-icons">delete</i>
            </button>
            <button mat-icon-button [disabled]="!formIsEditable || !selectedCfgForm" (click)="saveFormData()" matTooltip="Save all changes" data-cy="forms-builder-polished-save-button">
              <i class="material-icons">save</i>
            </button>
            <button mat-icon-button [disabled]="!selectedCfgForm" (click)="editFormButtonPressed()" matTooltip="Edit selected form" data-cy="forms-builder-polished-edit-button">
              <i class="material-icons">edit</i>
            </button>
            <button mat-icon-button [disabled]="!selectedCfgForm" (click)="createNewFormButtonPressed()" matTooltip="Copy Selected form" data-cy="forms-builder-polished-copy-button">
              <i class="material-icons">content_copy</i>
            </button>
            <button mat-icon-button matTooltip="Create a new form" (click)="createNewFormButtonPressed()" data-cy="forms-builder-polished-add-button"><i class="material-icons">add</i></button>
            <button mat-icon-button [disabled]="!selectedCfgForm"
              (click)="clearChanges()"
              matTooltip="Clear all unsaved changes" data-cy="forms-builder-polished-undo-button">
              <i class="material-icons">undo</i>
            </button>
          </div>
        </div>
        <div class="form-search-container" data-cy="forms-builder-polished-search-container">
          <div data-cy="forms-builder-polished-search-input-container">
            <input class="form-search-input" type="text" placeholder="Search for form by name"
              [(ngModel)]="formSearchKeyword"
              (input)="searchForForm()" data-cy="forms-builder-polished-search-input" />
            </div>
            <div class="form-search-results" data-cy="forms-builder-polished-search-results">
              @if (isSearchingForForms) {
                <div class="search-spinner-holder" data-cy="forms-builder-polished-search-spinner">
                  <mat-spinner [diameter]="20" data-cy="forms-builder-polished-spinner-small"></mat-spinner>
                </div>
              }
              @if (!isSearchingForForms) {
                <div data-cy="forms-builder-polished-results-content">
                  @if (!formSearchResults) {
                    <div class="search-message" data-cy="forms-builder-polished-empty-message">
                    </div>
                  }
                  @if (formSearchResults && !formSearchResults.length) {
                    <div class="search-message" data-cy="forms-builder-polished-no-results">
                      No forms found
                    </div>
                  }
                  @for (formPreview of formSearchResults; track formPreview; let i = $index) {
                    <div class="form-preview" (click)="selectAndFetchCfgForm(formPreview.DFormId)" [class.selected]="formPreview.DFormId == selectedCfgFormPreviewId"
                      data-cy="forms-builder-polished-form-preview-{{i}}">
                      {{ formPreview.DFormName }}
                    </div>
                  }
                </div>
              }
            </div>
          </div>
          <div class="form-input-container" data-cy="forms-builder-polished-form-input">
            <div class="form-name-input-container" data-cy="forms-builder-polished-name-container">
              <input class="form-search-input" type="text" placeholder="Form name"
                [disabled]="!formIsEditable && selectedCfgForm !== null" [value]="selectedCfgForm?.DFormName" (input)="selectedCfgForm.DFormName = $event.target.value" data-cy="forms-builder-polished-form-name" />
              </div>
              @if (selectedCfgForm) {
                <div class="form-properties-container" data-cy="forms-builder-polished-form-properties">
                  <mat-accordion class="form-properties-accordion" [multi]="true">
                    <!-- Basic Properties Panel -->
                    <mat-expansion-panel [expanded]="true">
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          <lucide-icon name="info" [size]="20"></lucide-icon>
                          <span>Basic Properties</span>
                        </mat-panel-title>
                      </mat-expansion-panel-header>
                      <div class="property-field" data-cy="forms-builder-polished-category-container">
                        <label class="property-label">Category</label>
                        <tdo-dropdown-v2
                          placeholder=""
                          displayProperty="ItemDisplayValue"
                          [datasource]="categoryEnums"
                          [isDisabled]="!formIsEditable"
                          [value]="getCategoryValue(selectedCfgForm?.enumFormCategoryID)"
                          (selectionChange)="selectedCfgForm.enumFormCategoryID = $event.value.ValidValueItemId;"
                          data-cy="forms-builder-polished-category-dropdown">
                        </tdo-dropdown-v2>
                      </div>
                      <div class="property-field" data-cy="forms-builder-polished-datasource-container">
                        <label class="property-label">Data Source</label>
                        <tdo-dropdown-v2
                          placeholder=""
                          displayProperty="name"
                          [datasource]="cfgFormDataSourceList"
                          [isDisabled]="!formIsEditable"
                          [value]="getDataSourceValue(selectedCfgForm?.enumFormDataSourceID)"
                          (selectionChange)="selectedCfgForm.enumFormDataSourceID = $event.value.id;"
                          data-cy="forms-builder-polished-datasource-dropdown">
                        </tdo-dropdown-v2>
                      </div>
                      @if (selectedCfgForm?.enumFormDataSourceID == '00000030-1000-0000-0000-000000000002') {
                        <div class="property-field" data-cy="forms-builder-polished-type-container">
                          <label class="property-label">Type</label>
                          <tdo-dropdown-v2
                            placeholder=""
                            displayProperty="ItemDisplayValue"
                            [datasource]="customEnums"
                            [isDisabled]="!formIsEditable"
                            [value]="getCustomValue(selectedCfgForm?.enumCustomFormID)"
                            (selectionChange)="selectedCfgForm.enumCustomFormID = $event.value.ValidValueItemId;"
                            data-cy="forms-builder-polished-type-dropdown">
                          </tdo-dropdown-v2>
                        </div>
                      }
                    </mat-expansion-panel>
                    <!-- Version Management Panel -->
                    @if (selectedCfgForm?.enumFormDataSourceID !== '00000030-1000-0000-0000-000000000002') {
                      <mat-expansion-panel>
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            <lucide-icon name="git-branch" [size]="20"></lucide-icon>
                            <span>Version & Status</span>
                          </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="property-field" data-cy="forms-builder-polished-version-container">
                          <label class="property-label">Version</label>
                          <tdo-dropdown-v2
                            placeholder="Select version"
                            displayProperty="Version"
                            [datasource]="selectedCfgForm?.cfgDFormVersions"
                            [isDisabled]="!formIsEditable"
                            [value]="getVersion(selectedVersionId)"
                            (selectionChange)="selectCfgFormVersion($event.value);"
                            data-cy="forms-builder-polished-version-dropdown">
                          </tdo-dropdown-v2>
                        </div>
                        <div class="property-field" data-cy="forms-builder-polished-status-container">
                          <label class="property-label">Status</label>
                          <tdo-dropdown-v2
                            placeholder="Select status"
                            displayProperty="name"
                            [datasource]="cfgFormVersionStatusList"
                            [isDisabled]="!formIsEditable"
                            [value]="getVersionStatus(this.selectedCfgFormVersion?.enumDFormBuildStatusID)"
                            (selectionChange)="selectCfgFormVersionStatus($event.value)"
                            data-cy="forms-builder-polished-status-dropdown">
                          </tdo-dropdown-v2>
                        </div>
                      </mat-expansion-panel>
                    }
                    <!-- Form Options Panel -->
                    <mat-expansion-panel>
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          <lucide-icon name="sliders-horizontal" [size]="20"></lucide-icon>
                          <span>Form Options</span>
                        </mat-panel-title>
                      </mat-expansion-panel-header>
                      <div class="property-checkboxes">
                        <mat-checkbox
                          [disabled]="!formIsEditable"
                          [(ngModel)]="selectedCfgForm.isRequireSignature"
                          data-cy="forms-builder-polished-signature-checkbox">
                          Flag as needing signature
                        </mat-checkbox>
                        <mat-checkbox
                          [disabled]="!formIsEditable"
                          [(ngModel)]="selectedCfgForm.isToothRequired"
                          data-cy="forms-builder-polished-tooth-checkbox">
                          Require tooth selection
                        </mat-checkbox>
                        <mat-checkbox
                          [disabled]="!formIsEditable"
                          [(ngModel)]="selectedCfgForm.isSubmissionRequired"
                          data-cy="forms-builder-polished-submission-checkbox">
                          Show "Complete Form" button
                        </mat-checkbox>
                      </div>
                    </mat-expansion-panel>
                  </mat-accordion>
                </div>
              }
            </div>
            @if (awd) {
              <div class="form-version-selector-container" data-cy="forms-builder-polished-version-selector">
                <mat-form-field class="existing-form-select">
                  <mat-label>Select a form</mat-label>
                  @if (!cfgFormPreviewSelectListIsLoading) {
                    <mat-select [(ngModel)]="selectedCfgFormPreviewId">
                      @for (cfgFormPreview of cfgFormPreviewSelectList; track cfgFormPreview) {
                        <mat-option
                          [value]="cfgFormPreview.DFormId">
                          <div class="cfg-form-select-button cfg-form-button-name"
                            (click)="selectAndFetchCfgForm(cfgFormPreview.DFormId)">
                            {{ cfgFormPreview.DFormName }}
                          </div>
                        </mat-option>
                      }
                      <mat-option [value]="null">
                        <div class="cfg-form-select-button" (click)="createAndSelectNewCfgForm()"
                          matTooltip="Create a new form"><i class="material-icons">add</i></div>
                        </mat-option>
                      </mat-select>
                    }
                    @if (cfgFormPreviewSelectListIsLoading) {
                      <mat-select>
                        <mat-option [value]="null">
                          <mat-spinner [diameter]="20"></mat-spinner>
                        </mat-option>
                      </mat-select>
                    }
                  </mat-form-field>
                  <div>
                    <mat-form-field class="form-input-small margin-left-side">
                      @if (selectedCfgFormVersion) {
                        <input matInput type="number" placeholder="Revision"
                          [(ngModel)]="selectedCfgFormVersion.Revision">
                      }
                      @if (!selectedCfgFormVersion) {
                        <input matInput type="number" placeholder="Revision" disabled>
                      }
                    </mat-form-field>
                  </div>
                  <mat-form-field class="status-form-select form-select">
                    <mat-label>Status</mat-label>
                    @if (selectedCfgFormVersion) {
                      <mat-select [(ngModel)]="activeFormVersionStatus">
                        @for (formStatus of cfgFormVersionStatusList; track formStatus) {
                          <mat-option [value]="formStatus.name">
                            <div class="cfg-form-select-button cfg-form-button-name"
                              (click)="selectCfgFormVersionStatus(formStatus)">
                              {{ formStatus.name }}
                            </div>
                          </mat-option>
                        }
                      </mat-select>
                    }
                    @if (!selectedCfgFormVersion) {
                      <mat-select [disabled]="!selectedCfgFormVersion">
                        <mat-option [value]="null">
                        </mat-option>
                      </mat-select>
                    }
                  </mat-form-field>
                </div>
              }
            </div>
            <div style="flex-basis: 5px; min-width: 5px;"></div>
            <!-- PARAGRAPH DETAILS -->
            <div class="paragraph-detail-container" data-cy="forms-builder-polished-paragraph-details">
              <div class="paragraph-header">
                <h5 class="form-detail-title">Paragraphs</h5>
                <div class="form-action-button-container">
                  <button mat-icon-button (click)="toggleLivePreview()"
                    [matTooltip]="livePreviewEnabled ? 'Hide live preview' : 'Show live preview'"
                    [disabled]="!selectedCfgFormVersion"
                    [style.color]="livePreviewEnabled ? 'var(--tdo-primary)' : ''">
                    <i class="material-icons">{{livePreviewEnabled ? 'visibility' : 'visibility_off'}}</i>
                  </button>
                  <button mat-icon-button (click)="openPreview()"
                    matTooltip="Preview form version (full screen)"
                    [disabled]="!selectedCfgFormVersion">
                    <i class="material-icons">open_in_new</i>
                  </button>
                  <button mat-icon-button matTooltip="Create a new paragraph"
                    [disabled]="!formIsEditable || !selectedCfgFormVersion"
                    (click)="createNewDFormParagraph()">
                    <i class="material-icons">add</i>
                  </button>
                  <button mat-icon-button [disabled]="!formIsEditable || !selectedCfgFormParagraph"
                    matTooltip="Delete selected paragraph"
                    (click)="deleteParagraph()">
                    <i class="material-icons">clear</i>
                  </button>
                </div>
              </div>
              @if (!selectedCfgFormVersion) {
                <div class="no-paragraph-message">
                  Select a form and a version to load paragraphs
                </div>
              }
              @if (selectedCfgFormVersion) {
                <mat-tab-group class="paragraph-tabs"
                  [(selectedIndex)]="paragraphTabIndex"
                  (selectedIndexChange)="onParagraphTabChange($event)">
                  <!-- LIST TAB -->
                  <mat-tab>
                    <ng-template mat-tab-label>
                      <lucide-icon name="list" [size]="20" class="tab-icon"></lucide-icon>
                      <span>List ({{ selectedCfgFormVersion.cfgDFormParagraphs.length }})</span>
                    </ng-template>
                    <div class="paragraph-results">
                      @if (selectedCfgFormVersion) {
                        <div
                          (cdkDropListDropped)="paragraphReOrderEvent($event, selectedCfgFormVersion.cfgDFormParagraphs)"
                          class="paragraph-boundary"
                          cdkDropList>
                          @for (paragraph of selectedCfgFormVersion.cfgDFormParagraphs; track paragraph; let i = $index) {
                            <div class="paragraph-preview"
                              [cdkDragDisabled]="!formIsEditable"
                              cdkDragBoundary=".paragraph-boundary"
                              cdkDrag
                              cdkDragLockAxis="y"
                              [class.selected]="paragraph.DFormParagraphId == selectedParagraphId"
                              >
                              <div (click)="selectDFormParagraph(paragraph)" class="paragraph-name-text">
                                <span class="paragraph-number">{{ i + 1 }}.</span>
                                {{ paragraph.ParagraphName }}
                              </div>
                              @if (formIsEditable) {
                                <div class="dragable-paragraph-container" cdkDragHandle>
                                  <i class="material-icons">reorder</i>
                                </div>
                              }
                              @if (!formIsEditable) {
                                <div (click)="selectDFormParagraph(paragraph)"
                                  class="dragable-paragraph-container-disabled"
                                  >
                                  <i class="material-icons">reorder</i>
                                </div>
                              }
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </mat-tab>
                  <!-- PROPERTIES TAB -->
                  <mat-tab>
                    <ng-template mat-tab-label>
                      <lucide-icon name="settings" [size]="20" class="tab-icon"></lucide-icon>
                      <span>Properties</span>
                    </ng-template>
                    @if (selectedCfgFormParagraph) {
                      <div class="paragraph-properties-content">
                        <div class="property-field">
                          <label class="property-label">Paragraph Name</label>
                          <input class="form-search-input"
                            type="text"
                            placeholder="Paragraph name"
                            [disabled]="!formIsEditable"
                            [(ngModel)]="selectedCfgFormParagraph.ParagraphName"
                            (input)="onParagraphNameChange()"
                            maxlength="50" />
                          </div>
                          <div class="property-field">
                            <label class="property-label">Orientation</label>
                            <mat-select [(ngModel)]="activeParagraphOrientation"
                              [disabled]="!formIsEditable"
                              class="property-select">
                              @for (orientation of cfgFormParagraphOrientationList; track orientation) {
                                <mat-option
                                  [value]="orientation.id">
                                  <div (click)="selectParagraphOrientation(orientation.id)">
                                    {{ orientation.name }}
                                  </div>
                                </mat-option>
                              }
                            </mat-select>
                          </div>
                          <div class="property-field">
                            <label class="property-label">Item Layout</label>
                            <mat-select [(ngModel)]="activeParagraphItemLayout"
                              [disabled]="!formIsEditable"
                              class="property-select">
                              @for (layout of cfgFormItemLayoutList; track layout) {
                                <mat-option
                                  [value]="layout.id">
                                  <div (click)="selectParagraphItemLayout(layout.id)">
                                    {{ layout.name }}
                                  </div>
                                </mat-option>
                              }
                            </mat-select>
                          </div>
                          <div class="property-field paragraph-options">
                            <mat-checkbox
                              class="checkbox-button"
                              [(ngModel)]="selectedCfgFormParagraph.PageBreakAfter"
                              (change)="syncLivePreview()">
                              Page break after paragraph
                            </mat-checkbox>
                            @if (formIsEditable) {
                              <mat-checkbox
                                class="checkbox-button"
                                [(ngModel)]="selectedCfgFormParagraph.isRepeting"
                                (change)="syncLivePreview()"
                                >
                                Is repeatable
                              </mat-checkbox>
                            }
                          </div>
                        </div>
                      }
                      @if (!selectedCfgFormParagraph) {
                        <div class="no-paragraph-selected">
                          Select a paragraph to view properties
                        </div>
                      }
                    </mat-tab>
                  </mat-tab-group>
                }
              </div>
            </div>
            <!-- HIERARCHY BREADCRUMB -->
            @if (selectedCfgForm) {
              <div class="hierarchy-breadcrumb mat-elevation-z1" data-cy="forms-builder-breadcrumb">
                <div class="breadcrumb-level active">
                  <lucide-icon name="file-text" [size]="20"></lucide-icon>
                  <span class="breadcrumb-label">{{ selectedCfgForm.DFormName }}</span>
                </div>
                <lucide-icon name="chevron-right" [size]="20" class="breadcrumb-separator"></lucide-icon>
                <div class="breadcrumb-level" [class.active]="selectedCfgFormVersion" [class.inactive]="!selectedCfgFormVersion">
                  <lucide-icon name="list-ordered" [size]="20"></lucide-icon>
                  @if (selectedCfgFormVersion) {
                    <span class="breadcrumb-label">Version {{ selectedCfgFormVersion.Version }}.{{ selectedCfgFormVersion.Revision }}</span>
                  }
                  @if (!selectedCfgFormVersion) {
                    <span class="breadcrumb-label breadcrumb-hint">Select a version</span>
                  }
                </div>
                @if (selectedCfgFormVersion) {
                  <lucide-icon name="chevron-right" [size]="20" class="breadcrumb-separator"></lucide-icon>
                }
                @if (selectedCfgFormVersion) {
                  <div class="breadcrumb-level" [class.active]="selectedCfgFormParagraph" [class.inactive]="!selectedCfgFormParagraph">
                    <lucide-icon name="align-justify" [size]="20"></lucide-icon>
                    @if (selectedCfgFormParagraph) {
                      <span class="breadcrumb-label">{{ selectedCfgFormParagraph.ParagraphName }}</span>
                    }
                    @if (!selectedCfgFormParagraph) {
                      <span class="breadcrumb-label breadcrumb-hint">Select a paragraph</span>
                    }
                  </div>
                }
                @if (selectedCfgFormParagraph) {
                  <lucide-icon name="chevron-right" [size]="20" class="breadcrumb-separator"></lucide-icon>
                }
                @if (selectedCfgFormParagraph) {
                  <div class="breadcrumb-level">
                    <lucide-icon name="layout-grid" [size]="20"></lucide-icon>
                    <span class="breadcrumb-label">{{ getTotalItemCount() }} Items</span>
                  </div>
                }
              </div>
            }
            <!-- PARAGRAPH BUILDER -->
            <div class="paragraph-builder-wrapper" data-cy="forms-builder-polished-builder-wrapper">
              <!-- LIVE PREVIEW PANEL -->
              @if (livePreviewEnabled && selectedCfgFormVersion) {
                <div class="live-preview-panel mat-elevation-z2"
                  style="flex: 1; height: 100%; overflow: hidden; border-radius: 10px; padding: 10px; min-width: 0;"
                  data-cy="forms-builder-polished-live-preview">
                  <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
                    <h5 style="margin: 0;">Live Preview</h5>
                  </div>
                  <div style="height: calc(100% - 40px); overflow: auto;">
                    @if (livePreviewCfgFormVersion) {
                      <app-forms-form
                        [cfgFormVersion]="livePreviewCfgFormVersion"
                        [isPreviewMode]="true"
                        [saveEnabled]="false"
                        [actionsEnabled]="false">
                      </app-forms-form>
                    }
                  </div>
                </div>
              }
              <div class="main-builder-content" [style.flex]="livePreviewEnabled ? '1' : '1'" data-cy="forms-builder-polished-builder-content">
                <div class="paragraph-builder-container mat-elevation-z2" data-cy="forms-builder-polished-builder-container">
                  <h5 data-cy="forms-builder-polished-builder-title">Paragraph Builder</h5>
                  <!-- Empty state when no form selected -->
                  @if (!selectedCfgForm) {
                    <div class="empty-state" data-cy="forms-builder-empty-no-form">
                      <lucide-icon name="file-text" [size]="20"></lucide-icon>
                      <h3>Welcome to Form Builder</h3>
                      <p>Search for an existing form or create a new one to get started building your medical forms.</p>
                      <div class="empty-state-actions">
                        <button mat-raised-button color="primary" (click)="createNewFormButtonPressed()">
                          <lucide-icon name="plus" [size]="20"></lucide-icon>
                          Create New Form
                        </button>
                      </div>
                    </div>
                  }
                  <!-- Empty state when no version selected -->
                  @if (!selectedCfgFormVersion && selectedCfgForm) {
                    <div class="empty-state" data-cy="forms-builder-empty-no-version">
                      <lucide-icon name="git-branch" [size]="20"></lucide-icon>
                      <h3>No Version Selected</h3>
                      <p>Select a version to begin editing, or create a new version of this form.</p>
                      <div class="empty-state-actions">
                        <button mat-raised-button color="primary" (click)="editFormButtonPressed()">
                          <lucide-icon name="plus" [size]="20"></lucide-icon>
                          Create Version
                        </button>
                      </div>
                    </div>
                  }
                  <!-- Empty state when no paragraph selected -->
                  @if (!selectedParagraphOrganizer && selectedCfgFormVersion) {
                    <div class="empty-state" data-cy="forms-builder-empty-no-paragraph">
                      <lucide-icon name="align-justify" [size]="20"></lucide-icon>
                      <h3>No Paragraph Selected</h3>
                      <p>Select a paragraph from the list on the left to begin building your form, or create a new paragraph.</p>
                      <div class="empty-state-actions">
                        <button mat-raised-button color="primary" (click)="createNewDFormParagraph()" [disabled]="!formIsEditable">
                          <lucide-icon name="plus" [size]="20"></lucide-icon>
                          Create Paragraph
                        </button>
                      </div>
                    </div>
                  }
                  @if (selectedParagraphOrganizer) {
                    <div class="paragraph-row-boundary"
                      (cdkDropListDropped)="dropEventOnRow($event)"
                      cdkDropList
                      data-cy="forms-builder-polished-row-boundary">
                      <!-- Insert row at top -->
                      @if (formIsEditable) {
                        <div class="row-insert-zone">
                          <button mat-stroked-button
                            color="primary"
                            class="insert-row-button"
                            matTooltip="Add a new row at the beginning of the paragraph"
                            (click)="insertRowAt(0)">
                            <lucide-icon name="plus" [size]="20"></lucide-icon>
                            <span>Insert Row at Top</span>
                          </button>
                        </div>
                      }
                      @for (row of selectedParagraphOrganizer; track row; let i = $index) {
                        <div
                          cdkDragLockAxis="y"
                          cdkDragBoundary=".paragraph-row-boundary"
                          [cdkDragDisabled]="!formIsEditable"
                          cdkDrag
                          class="row-wrapper"
                          data-cy="forms-builder-polished-row-{{i}}">
                          <!-- Row number indicator -->
                          @if (formIsEditable) {
                            <div class="row-number-indicator">
                              <span class="row-number">{{ i + 1 }}</span>
                              @if (row.length === 0) {
                                <button mat-icon-button
                                  class="delete-row-button"
                                  (click)="deleteRowAt(i)"
                                  matTooltip="Delete this row"
                                  >
                                  <lucide-icon name="trash-2" [size]="20"></lucide-icon>
                                </button>
                              }
                            </div>
                          }
                          <div class="paragraph-row-container">
                            <div class="paragraph-row"
                              cdkDropList
                              [cdkDropListConnectedTo]="connectedDragDropParagraphs"
                              [cdkDropListData]="row"
                              cdkDropListOrientation="horizontal"
                              (cdkDropListDropped)="dropEventInRow($event, row, i)"
                              id="paragraphRow{{i}}"
                              [class.empty-row]="row.length === 0"
                              data-cy="forms-builder-polished-row-list-{{i}}">
                              <div class="row-drag-handle" [class.disabled-draggable]="!formIsEditable" cdkDragHandle>
                                <i class="material-icons row-drag-icon">drag_indicator</i>
                                <span class="row-label">Row {{ i + 1 }}</span>
                              </div>
                              <!-- Empty state for empty rows -->
                              @if (row.length === 0) {
                                <div class="empty-row-message">
                                  <lucide-icon name="inbox" [size]="20"></lucide-icon>
                                  <span>Drag items here or delete this row</span>
                                </div>
                              }
                              @for (item of row; track item; let j = $index) {
                                <div
                                  class="inline"
                                  cdkDrag
                                  [class.disabled-draggable]="!formIsEditable"
                                  [cdkDragDisabled]="!formIsEditable"
                                  data-cy="forms-builder-polished-item-{{i}}-{{j}}">
                                  @if (!item.xauditDeleted) {
                                    <div class="row-column draggable-item draggable-container"
                                      [class.disabled-draggable]="!formIsEditable"
                                      [class.clickable-item]="true"
                                      (click)="openItemDetailDetail(item, i, j)"
                                      data-cy="forms-builder-polished-item-container-{{i}}-{{j}}">
                                      <!-- Item Card Content -->
                                      <div class="item-card-content">
                                        <mat-icon class="item-type-icon" matTooltip="{{getItemLabel(item).name}}">
                                          {{ getItemLabel(item).icon }}
                                        </mat-icon>
                                        <div class="item-card-details" data-cy="forms-builder-polished-item-details-{{i}}-{{j}}">
                                          <div class="item-name-display">{{ item.DFormItemName || 'Unnamed Item' }}</div>
                                          @if (item.Label) {
                                            <div class="item-label-display">{{ item.Label }}</div>
                                          }
                                        </div>
                                      </div>
                                      <!-- Item Card Actions -->
                                      <div class="item-card-actions">
                                        <button mat-icon-button
                                          class="item-settings-button"
                                          (click)="openItemDetailDetail(item, i, j); $event.stopPropagation()"
                                          matTooltip="Configure item"
                                          data-cy="forms-builder-polished-item-settings-{{i}}-{{j}}">
                                          <lucide-icon name="settings" [size]="20"></lucide-icon>
                                        </button>
                                        @if (formIsEditable) {
                                          <button mat-icon-button
                                            class="item-delete-button"
                                            (click)="deleteItemFromRow(item, i, j); $event.stopPropagation()"
                                            matTooltip="Delete item"
                                            data-cy="forms-builder-polished-item-delete-{{i}}-{{j}}">
                                            <lucide-icon name="trash-2" [size]="20"></lucide-icon>
                                          </button>
                                        }
                                      </div>
                                    </div>
                                  }
                                </div>
                              }
                            </div>
                          </div>
                          <!-- Insert row between -->
                          @if (formIsEditable) {
                            <div class="row-insert-zone row-insert-between">
                              <button mat-stroked-button
                                color="primary"
                                class="insert-row-button insert-row-button-compact"
                                matTooltip="Insert a new row after row {{ i + 1 }}"
                                (click)="insertRowAt(i + 1)">
                                <lucide-icon name="plus" [size]="20"></lucide-icon>
                                <span>Insert Row</span>
                              </button>
                            </div>
                          }
                        </div>
                      }
                      <!-- Add row at bottom (kept for legacy / when no rows exist) -->
                      @if (formIsEditable && selectedParagraphOrganizer.length === 0) {
                        <div class="row-insert-zone">
                          <button mat-raised-button
                            color="primary"
                            class="add-first-row-button"
                            matTooltip="Add the first row to this paragraph"
                            (click)="addParagraphRowToOrganizer()">
                            <lucide-icon name="plus" [size]="20"></lucide-icon>
                            <span>Add First Row</span>
                          </button>
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
              <!-- ITEM DRAWER -->
              <div class="item-drawer mat-elevation-z2" data-cy="forms-builder-polished-item-drawer">
                <div style="flex-shrink: 0;" data-cy="forms-builder-polished-item-drawer-header">
                  <h5 class="item-drawer-title" data-cy="forms-builder-polished-item-drawer-title">Items</h5>
                  @if (selectedParagraphOrganizer && formIsEditable) {
                    <i class="material-icons item-drawer-tooltip" matTooltip="Drag and drop items from this list into the paragraph builder to add them to a row." data-cy="forms-builder-polished-item-drawer-help">help</i>
                  }
                </div>
                <!-- Search Bar -->
                <div class="item-search-container" data-cy="forms-builder-polished-item-search">
                  <mat-form-field class="item-search-field" appearance="outline">
                    <mat-label>Search items</mat-label>
                    <input matInput
                      [(ngModel)]="itemSearchQuery"
                      (input)="filterItems()"
                      placeholder="Name or ID..."
                      data-cy="forms-builder-polished-item-search-input">
                      @if (itemSearchQuery) {
                        <button mat-icon-button matSuffix
                          (click)="clearItemSearch()"
                          data-cy="forms-builder-polished-item-search-clear">
                          <lucide-icon name="x" [size]="20"></lucide-icon>
                        </button>
                      }
                      <lucide-icon name="search" [size]="20" matPrefix></lucide-icon>
                    </mat-form-field>
                  </div>
                  <!-- Scrollable Area with Expansion Panels -->
                  <div id="itemListDropList"
                    #cfgFormItemTypeDropList="cdkDropList"
                    [cdkDropListConnectedTo]="connectedDragDropParagraphs"
                    [cdkDropListData]="cfgFormItemTypeList"
                    (cdkDropListDropped)="organizeItemTypeList()"
                    cdkDropList
                    data-cy="forms-builder-polished-item-list">
                    <mat-accordion class="item-groups-accordion">
                      <!-- CONSENT FORM Expansion Panel -->
                      <mat-expansion-panel [(expanded)]="consentFormGroupExpanded"
                        [disabled]="filteredConsentFormItems.length === 0"
                        data-cy="forms-builder-polished-consent-panel">
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            <lucide-icon name="file-text" [size]="20" class="group-icon"></lucide-icon>
                            <span class="group-title">CONSENT FORM</span>
                            <span class="group-count">({{ filteredConsentFormItems.length }})</span>
                          </mat-panel-title>
                        </mat-expansion-panel-header>
                        @for (item of filteredConsentFormItems; track item; let i = $index) {
                          <div class="item-picker-container draggable-container"
                            [class.disabled-draggable]="!formIsEditable"
                            [cdkDragDisabled]="!formIsEditable"
                            [cdkDragData]="item"
                            cdkDrag
                            data-cy="forms-builder-polished-consent-item-{{i}}">
                            <div class="item-picker-drag-handle">
                              <lucide-icon name="grip-vertical" [size]="20" class="drag-icon"></lucide-icon>
                            </div>
                            <div class="item-picker-content">
                              <div class="item-picker-name">{{ item.name }}</div>
                              <div class="item-picker-header">
                                <mat-icon class="item-type-icon">{{ item.icon }}</mat-icon>
                                <span class="item-picker-type">{{ item.name }}</span>
                              </div>
                            </div>
                          </div>
                        }
                        @if (filteredConsentFormItems.length === 0) {
                          <div class="no-items-message">
                            No consent form items found
                          </div>
                        }
                      </mat-expansion-panel>
                      <!-- OTHER Expansion Panel -->
                      <mat-expansion-panel [(expanded)]="otherGroupExpanded"
                        [disabled]="filteredOtherItems.length === 0"
                        data-cy="forms-builder-polished-other-panel">
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            <lucide-icon name="layout-dashboard" [size]="20" class="group-icon"></lucide-icon>
                            <span class="group-title">OTHER</span>
                            <span class="group-count">({{ filteredOtherItems.length }})</span>
                          </mat-panel-title>
                        </mat-expansion-panel-header>
                        @for (item of filteredOtherItems; track item; let i = $index) {
                          <div class="item-picker-container draggable-container"
                            [class.disabled-draggable]="!formIsEditable"
                            [cdkDragDisabled]="!formIsEditable"
                            [cdkDragData]="item"
                            cdkDrag
                            data-cy="forms-builder-polished-other-item-{{i}}">
                            <div class="item-picker-drag-handle">
                              <lucide-icon name="grip-vertical" [size]="20" class="drag-icon"></lucide-icon>
                            </div>
                            <div class="item-picker-content">
                              <div class="item-picker-name">{{ item.name }}</div>
                              <div class="item-picker-header">
                                <mat-icon class="item-type-icon">{{ item.icon }}</mat-icon>
                                <span class="item-picker-type">{{ item.name }}</span>
                              </div>
                            </div>
                          </div>
                        }
                        @if (filteredOtherItems.length === 0) {
                          <div class="no-items-message">
                            No other items found
                          </div>
                        }
                      </mat-expansion-panel>
                    </mat-accordion>
                  </div>
                </div>
              </div>
            </div>
          }

          @if (isLoading) {
            <div class="spinner-container" data-cy="forms-builder-polished-loading">
              <mat-spinner data-cy="forms-builder-polished-main-spinner"></mat-spinner>
            </div>
          }
